import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Bell, Play, Clock, Mail, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RemindersTab = ({ 
  reminderSettings, 
  setReminderSettings,
  checkingReminders,
  setCheckingReminders,
  getAuthHeaders, 
  onRefresh 
}) => {
  
  const handleCheckReminders = async () => {
    setCheckingReminders(true);
    try {
      const response = await fetch(`${API_URL}/api/reminders/check`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(`Checked ${data.checked || 0} assignments, sent ${data.sent || 0} reminders`);
      }
    } catch (error) {
      toast.error('Failed to check reminders');
    } finally {
      setCheckingReminders(false);
    }
  };

  const handleUpdateReminders = async () => {
    try {
      const response = await fetch(`${API_URL}/api/reminders/settings`, {
        method: 'PUT',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(reminderSettings)
      });
      
      if (response.ok) {
        toast.success('Reminder settings updated');
        onRefresh();
      }
    } catch (error) {
      toast.error('Failed to update reminder settings');
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5" />
            SMS Reminder Settings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between">
            <div>
              <Label>24-Hour Reminder</Label>
              <p className="text-sm text-muted-foreground">Send reminder 24 hours before assignment</p>
            </div>
            <Switch
              checked={reminderSettings.reminder_24h}
              onCheckedChange={(checked) => setReminderSettings({ ...reminderSettings, reminder_24h: checked })}
            />
          </div>
          
          <div className="flex items-center justify-between">
            <div>
              <Label>2-Hour Reminder</Label>
              <p className="text-sm text-muted-foreground">Send reminder 2 hours before assignment</p>
            </div>
            <Switch
              checked={reminderSettings.reminder_2h}
              onCheckedChange={(checked) => setReminderSettings({ ...reminderSettings, reminder_2h: checked })}
            />
          </div>
          
          <Button onClick={handleUpdateReminders}>Save Changes</Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5" />
            Manual Reminder Check
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            Manually trigger a check for pending reminders. This will send reminders for any assignments 
            that are due within the configured timeframes.
          </p>
          <Button onClick={handleCheckReminders} disabled={checkingReminders}>
            {checkingReminders ? (
              <>
                <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                Checking...
              </>
            ) : (
              <>
                <Play className="h-4 w-4 mr-2" />
                Check & Send Reminders Now
              </>
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default RemindersTab;
